import React, {

    useState

} from "react";


export default function PillButton({

    isActive,

    label,

    onClick,

    color = "#45afe0"

})

{

    //--------------------------------------------------------
    // State
    //--------------------------------------------------------

    const [isHover, setIsHover] =

        useState(false);


    //========================================================
    // Styles
    //========================================================


    //--------------------------------------------------------
    // Base
    //--------------------------------------------------------

    const baseStyle =

    {

        borderRadius:

            "20px",

        padding:

            "6px 18px",

        fontSize:

            "13px",

        fontWeight:

            isActive

                ? "500"

                : "400",

        cursor:

            "pointer",

        transition:

            "all 0.18s ease",

        position:

            "relative",

        display:

            "inline-flex",

        alignItems:

            "center",

        justifyContent:

            "center",

        marginRight:

            "8px",

        minWidth:

            "80px",

        boxSizing:

            "border-box",

        overflow:

            "hidden"

    };


    //--------------------------------------------------------
    // Active
    //--------------------------------------------------------

    const activeStyle =

    {

        //----------------------------------------------------
        // Flat Glass structural graphite
        //----------------------------------------------------

        background:

            `linear-gradient(
                145deg,
                #292d31 0%,
                #181c1f 52%,
                #0b0d0f 100%
            )`,

        color:

            "#ffffff",

        border:

            "1px solid rgba(255,255,255,0.08)",

        boxShadow:

            "0 4px 10px rgba(0,0,0,0.16)",

        transform:

            "translateY(0)"

    };


    //--------------------------------------------------------
    // Inactive
    //--------------------------------------------------------

    const inactiveStyle =

    {

        background:

            isHover

                ? "#edf3f7"

                : "#f4f7f9",

        color:

            isHover

                ? "#252b31"

                : "#687684",

        border:

            isHover

                ? "1px solid rgba(37,43,49,0.14)"

                : "1px solid rgba(37,43,49,0.06)",

        boxShadow:

            "none",

        transform:

            "translateY(0)"

    };


    //--------------------------------------------------------
    // Combined
    //--------------------------------------------------------

    const style =

    {

        ...baseStyle,

        ...(

            isActive

                ? activeStyle

                : inactiveStyle

        )

    };


    //--------------------------------------------------------
    // Active indicator
    //--------------------------------------------------------

    const underlineStyle =

        isActive

            ? {

                position:

                    "absolute",

                bottom:

                    "0px",

                left:

                    "22%",

                width:

                    "56%",

                height:

                    "2px",

                background:

                    color

            }

            : null;


    //========================================================
    // Render
    //========================================================

    return (

        <div

            onClick={

                onClick

            }

            style={

                style

            }

            onMouseEnter={

                () =>

                    setIsHover(true)

            }

            onMouseLeave={

                () =>

                    setIsHover(false)

            }

        >

            {label}


            {

                underlineStyle

                &&

                <div

                    style={

                        underlineStyle

                    }

                />

            }

        </div>

    );

}